// This is adapted from "@rails/activestorage/src/blob_upload" for Shopify

interface DirectUploadData {
  url: string;
  headers: Record<string, string>;
}

interface BlobUploadData {
  file: File;
  directUploadData: DirectUploadData;
}

type UploadCallback = (error: string | null, response?: string) => void;

export class BlobUpload {
  blob: BlobUploadData;
  file: File;
  xhr: XMLHttpRequest;
  callback?: UploadCallback;

  constructor(blob: BlobUploadData) {
    this.blob = blob;
    this.file = blob.file;

    const { url, headers } = blob.directUploadData;

    this.xhr = new XMLHttpRequest();
    this.xhr.open('PUT', url, true);
    this.xhr.responseType = 'text';
    for (const key in headers) {
      if (headers[key]) {
        this.xhr.setRequestHeader(key, headers[key]);
      }
    }
    this.xhr.addEventListener('load', () => this.requestDidLoad());
    this.xhr.addEventListener('error', () => this.requestDidError());
  }

  create(callback: UploadCallback): void {
    this.callback = callback;
    this.xhr.send(this.file.slice());
  }

  requestDidLoad(): void {
    const { status, response } = this.xhr;
    if (status >= 200 && status < 300) {
      if (this.callback) {
        this.callback(null, response);
      }
    } else {
      this.requestDidError();
    }
  }

  requestDidError(): void {
    if (this.callback) {
      this.callback(
        `Error storing "${this.file.name}". Status: ${this.xhr.status}`,
      );
    }
  }
}
